/* eslint-disable */
<template>
  <div class="p-6 max-w-7xl mx-auto bg-white rounded-lg shadow-md">
    <!-- Header with Logo -->
    <div class="flex justify-between items-center mb-6 pb-4 border-b-2 border-blue-700">
      <div>
        <h2 class="text-3xl font-bold text-blue-900 uppercase">Afya Nafuu Cover</h2>
        <p class="text-gray-600 mt-1">Affordable Health Insurance Quote Calculator</p>
      </div>
      <div class="flex justify-end">
        <img :src="logo" alt="Logo" class="h-20 w-auto object-contain" />
      </div>
    </div>

    <!-- Premium Preview -->
    <div v-if="!hasPrincipal && previewPremium > 0" class="mb-6 p-4 bg-blue-50 border-l-4 border-blue-400 rounded-r-lg">
      <div class="flex justify-between items-center">
        <div>
          <h3 class="font-semibold text-blue-900">Estimated Premium</h3>
          <p class="text-sm text-gray-600">For the current selection</p>
        </div>
        <div class="text-right">
          <p class="text-xl font-bold text-green-600">{{ formatAmount(previewPremium) }}</p>
          <p class="text-xs text-gray-500">per year</p>
        </div>
      </div>
    </div>

    <!-- Add Principal (only shown until the principal exists) -->
    <form v-if="!hasPrincipal" @submit.prevent="addEntry" class="mb-8 p-6 bg-gray-50 rounded-lg shadow-md border-t-4 border-blue-700">
      <h3 class="text-xl font-semibold text-blue-900 mb-1">Add Principal Member</h3>
      <p class="text-xs text-gray-500 mb-4">Add the principal first. Once added, you can add their spouse and children as dependants below.</p>
      <div class="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
        <!-- Member Name -->
        <div>
          <label for="memberName" class="block text-sm font-semibold text-blue-900 mb-1">Member Name</label>
          <input v-model="form.memberName" id="memberName" type="text" class="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition" required />
        </div>

        <!-- DOB -->
        <div>
          <label for="dob" class="block text-sm font-semibold text-blue-900 mb-1">Date of Birth</label>
          <input v-model="form.dob" id="dob" type="date" class="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition" required :max="maxDate" @change="calculatePreviewPremium"/>
        </div>

        <!-- Gender -->
        <div>
          <label for="gender" class="block text-sm font-semibold text-blue-900 mb-1">Gender</label>
          <select v-model="form.gender" id="gender" class="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition" required @change="calculatePreviewPremium">
            <option value="M">Male</option>
            <option value="F">Female</option>
          </select>
        </div>

        <!-- Benefits -->
        <div>
          <label for="inpatientBenefit" class="block text-sm font-semibold text-blue-900 mb-1">
            Inpatient Benefit
            <span v-if="form.inpatientBenefit" class="text-xs bg-blue-100 text-blue-800 px-2 py-1 rounded ml-2">
              +{{ formatAmount(calculatePreviewBenefit('inpatient', form.inpatientBenefit)) }}
            </span>
          </label>
          <select v-model="form.inpatientBenefit" id="inpatientBenefit" class="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition" required @change="calculatePreviewPremium">
            <option v-for="amount in inpatientAmounts" :key="amount" :value="amount">{{ formatAmount(amount) }}</option>
          </select>
        </div>

        <div>
          <label for="outpatientBenefit" class="block text-sm font-semibold text-blue-900 mb-1">
            Outpatient Benefit
            <span v-if="form.outpatientBenefit" class="text-xs bg-green-100 text-green-800 px-2 py-1 rounded ml-2">
              +{{ formatAmount(calculatePreviewBenefit('outpatient', form.outpatientBenefit)) }}
            </span>
          </label>
          <select v-model="form.outpatientBenefit" id="outpatientBenefit" class="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition" @change="calculatePreviewPremium">
            <option v-for="amount in outpatientAmounts" :key="amount" :value="amount">{{ formatAmount(amount) }}</option>
          </select>
        </div>

        <div>
          <label for="maternityBenefit" class="block text-sm font-semibold text-blue-900 mb-1">
            Maternity Benefit
            <span v-if="form.maternityBenefit" class="text-xs bg-pink-100 text-pink-800 px-2 py-1 rounded ml-2">
              +{{ formatAmount(calculatePreviewBenefit('maternity', form.maternityBenefit)) }}
            </span>
          </label>
          <select v-model="form.maternityBenefit" id="maternityBenefit" class="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition" :disabled="isMaternityDisabled" @change="calculatePreviewPremium">
            <option v-for="amount in maternityAmounts" :key="amount" :value="amount">{{ formatAmount(amount) }}</option>
          </select>
        </div>

        <div>
          <label for="feminaPlusBenefit" class="block text-sm font-semibold text-blue-900 mb-1">
            Femina Plus Benefit
            <span v-if="form.feminaPlusBenefit" class="text-xs bg-purple-100 text-purple-800 px-2 py-1 rounded ml-2">
              +{{ formatAmount(calculatePreviewFeminaPlus(form.feminaPlusBenefit)) }}
            </span>
          </label>
          <select v-model="form.feminaPlusBenefit" id="feminaPlusBenefit" class="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition" :disabled="isMaternityDisabled" @change="calculatePreviewPremium">
            <option v-for="benefit in feminaPlusBenefits" :key="benefit" :value="benefit">{{ benefit || 'None' }}</option>
          </select>
        </div>
      </div>

      <!-- Submit Button -->
      <div class="flex items-end gap-2 mt-6">
        <button type="submit" class="flex-1 bg-blue-700 hover:bg-blue-800 text-white font-bold py-2 px-4 rounded-lg shadow-md transition duration-300 transform hover:scale-105">
          <span v-if="previewPremium > 0">
            Add Principal - {{ formatAmount(previewPremium) }}
          </span>
          <span v-else>
            Add Principal
          </span>
        </button>
      </div>
    </form>

    <!-- Principal added: manage dependants instead -->
    <div v-else class="mb-8 p-6 bg-gray-50 rounded-lg shadow-md border-t-4 border-blue-700">
      <div class="flex flex-col sm:flex-row sm:justify-between sm:items-start gap-3 mb-6 pb-4 border-b border-gray-200">
        <div>
          <h3 class="text-xl font-semibold text-blue-900">Principal Member</h3>
          <p class="text-sm text-gray-700 mt-1">
            {{ principalEntry.memberName }} &bull; {{ principalEntry.age }} yrs &bull; {{ principalEntry.gender === 'F' ? 'Female' : 'Male' }}
          </p>
          <p class="text-xs text-gray-500 mt-1">
            Shared benefits — Inpatient: {{ formatAmount(principalEntry.inpatientBenefit) }}<span v-if="principalEntry.outpatientBenefit"> &middot; Outpatient: {{ formatAmount(principalEntry.outpatientBenefit) }}</span>
          </p>
        </div>
      </div>

      <!-- Dependants Section -->
      <div>
        <div class="flex justify-between items-center mb-2">
          <h4 class="text-md font-semibold text-blue-900">Dependants (Spouse / Children)</h4>
          <button type="button" @click="addDependantRow"
            class="text-sm bg-blue-100 hover:bg-blue-200 text-blue-700 font-semibold py-1 px-3 rounded-lg transition">
            + Add Dependant
          </button>
        </div>

        <p v-if="dependantRows.length === 0 && existingDependants.length === 0" class="text-sm text-gray-500 mb-2">
          No dependants added yet. Dependants inherit the inpatient and outpatient limits selected for the principal.
        </p>

        <div v-if="existingDependants.length" class="mb-4 space-y-2">
          <div v-for="dep in existingDependants" :key="dep.entry_id" class="flex justify-between items-center p-3 bg-white rounded-lg border border-gray-200 text-sm">
            <span>{{ dep.memberName }} <span class="text-gray-500">({{ dep.relationship }}, {{ dep.age }}y)</span></span>
            <span class="text-xs text-gray-400">Manage in the members list below</span>
          </div>
        </div>

        <div v-if="dependantError" class="mb-3 p-2 bg-red-50 border border-red-300 rounded-lg">
          <p class="text-red-600 text-sm font-medium">{{ dependantError }}</p>
        </div>

        <div v-for="(dependant, index) in dependantRows" :key="index"
          class="grid grid-cols-1 md:grid-cols-5 gap-4 mb-3 items-end p-3 bg-white rounded-lg border border-gray-200">
          <div>
            <label class="block text-xs font-semibold text-blue-900 mb-1">Name *</label>
            <input v-model="dependant.name" type="text" class="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition">
          </div>
          <div>
            <label class="block text-xs font-semibold text-blue-900 mb-1">Relationship *</label>
            <select v-model="dependant.relationship" class="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition">
              <option value="" disabled>Select</option>
              <option v-for="opt in availableDependantRelationshipOptions(index)" :key="opt" :value="opt">{{ opt }}</option>
            </select>
          </div>
          <div>
            <label class="block text-xs font-semibold text-blue-900 mb-1">Gender *</label>
            <select v-model="dependant.gender" class="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition">
              <option value="" disabled>Select</option>
              <option value="M">Male</option>
              <option value="F">Female</option>
            </select>
          </div>
          <div>
            <label class="block text-xs font-semibold text-blue-900 mb-1">Date of Birth *</label>
            <input v-model="dependant.dob" type="date" :max="maxDate" class="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition">
          </div>
          <div>
            <button type="button" @click="removeDependantRow(index)"
              class="w-full bg-red-100 hover:bg-red-200 text-red-700 font-semibold py-2 px-4 rounded-lg transition">
              Remove
            </button>
          </div>

          <div v-if="dependant.gender === 'F' && dependant.relationship === 'Spouse'" class="md:col-span-5 grid grid-cols-1 md:grid-cols-2 gap-4 pt-3 mt-1 border-t border-gray-100">
            <div>
              <label class="block text-xs font-semibold text-blue-900 mb-1">Maternity Benefit</label>
              <select v-model="dependant.maternityBenefit" class="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition">
                <option v-for="amount in maternityAmounts" :key="amount" :value="amount">{{ formatAmount(amount) }}</option>
              </select>
            </div>
            <div>
              <label class="block text-xs font-semibold text-blue-900 mb-1">Femina Plus Benefit</label>
              <select v-model="dependant.feminaPlusBenefit" class="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition">
                <option v-for="benefit in feminaPlusBenefits" :key="benefit" :value="benefit">{{ benefit || 'None' }}</option>
              </select>
            </div>
          </div>

          <div class="md:col-span-5 text-right text-xs text-gray-500" v-if="dependant.dob && dependant.gender && dependant.relationship">
            Estimated premium: <span class="font-semibold text-green-600">{{ formatAmount(calculateDependantPreviewPremium(dependant)) }}</span>
          </div>
        </div>

        <div v-if="dependantRows.length" class="flex items-end gap-2 mt-4">
          <button type="button" @click="saveDependants"
            class="flex-1 bg-blue-700 hover:bg-blue-800 text-white font-bold py-2 px-4 rounded-lg shadow-md transition duration-300 transform hover:scale-105">
            Save {{ dependantRows.length }} Dependant{{ dependantRows.length !== 1 ? 's' : '' }}
          </button>
        </div>
      </div>
    </div>

    <!-- Loading & Discount Section -->
    <div class="mb-8 p-6 bg-gradient-to-r from-purple-50 to-blue-50 rounded-lg shadow-md border-t-4 border-purple-600">
      <h3 class="text-lg font-semibold text-purple-900 mb-4">Premium Adjustments</h3>
      <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div>
          <label class="block text-sm font-semibold text-purple-900 mb-1">Loading Percentage</label>
          <div class="flex items-center gap-2">
            <input v-model.number="loadingPercentage" type="number" step="0.1" min="0" max="100"
              @input="updateLoadingDiscount"
              class="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500 transition">
            <span class="text-gray-600 font-semibold">%</span>
          </div>
          <p class="text-xs text-gray-500 mt-1">Increase premium by percentage (e.g., for high-risk cases)</p>
        </div>
        <div>
          <label class="block text-sm font-semibold text-purple-900 mb-1">Discount Percentage</label>
          <div class="flex items-center gap-2">
            <input v-model.number="discountPercentage" type="number" step="0.1" min="0" max="100"
              @input="updateLoadingDiscount"
              class="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500 transition">
            <span class="text-gray-600 font-semibold">%</span>
          </div>
          <p class="text-xs text-gray-500 mt-1">Reduce premium by percentage (e.g., for loyalty discounts)</p>
        </div>
      </div>
      <div class="mt-4 p-3 bg-yellow-50 rounded-lg border border-yellow-200">
        <p class="text-sm text-yellow-800">
          <span class="font-semibold">Note:</span> Loading and discount are applied to the total premium.
          Net effect = Basic Premium × (1 + Loading% - Discount%)
        </p>
      </div>
    </div>
  </div>

  <!---begin of pdf report -->
  <div class="p-6 max-w-7xl mx-auto bg-white rounded-lg shadow-md mt-6">
    <div class="flex justify-between items-center mb-6 pb-4 border-b-2 border-blue-700">
      <div>
        <h3 class="text-lg font-semibold text-blue-900">Client Details</h3>
        <p class="text-xs text-gray-500">Shown on the generated quote PDF</p>
      </div>
      <img :src="logo" alt="Logo" class="h-16 w-auto object-contain" />
    </div>
    <div class="mb-6 p-4 bg-gray-50 rounded-lg border border-gray-200 grid grid-cols-2 md:grid-cols-3 gap-4">
      <div>
        <p class="text-xs font-semibold text-blue-900 uppercase">Name</p>
        <p class="text-sm text-gray-700">{{ this.clientDetails.name || '-' }}</p>
      </div>
      <div>
        <p class="text-xs font-semibold text-blue-900 uppercase">Email</p>
        <p class="text-sm text-gray-700">{{ this.clientDetails.email || '-' }}</p>
      </div>
      <div>
        <p class="text-xs font-semibold text-blue-900 uppercase">Mobile</p>
        <p class="text-sm text-gray-700">{{ this.clientDetails.phone || '-' }}</p>
      </div>
    </div>

    <!-- Results Table -->
    <div v-if="entries.length" class="mt-6">
      <div class="flex justify-between items-center mb-4">
        <h3 class="text-xl font-bold text-blue-900">Members List ({{ entries.length }} member{{ entries.length !== 1 ? 's' : '' }})</h3>
      </div>
      <div class="overflow-x-auto">
        <table class="w-full border-collapse border border-blue-300 hidden md:table">
          <thead>
            <tr class="bg-blue-700 text-white">
              <th class="border border-blue-300 p-2">Member Name</th>
              <th class="border border-blue-300 p-2">DOB</th>
              <th class="border border-blue-300 p-2">Age</th>
              <th class="border border-blue-300 p-2">Gender</th>
              <th class="border border-blue-300 p-2">Relationship</th>
              <th class="border border-blue-300 p-2">Inpatient Limit</th>
              <th class="border border-blue-300 p-2">Inpatient Premium</th>
              <th class="border border-blue-300 p-2">Outpatient Limit</th>
              <th class="border border-blue-300 p-2">Outpatient Premium</th>
              <th class="border border-blue-300 p-2">Maternity Limit</th>
              <th class="border border-blue-300 p-2">Maternity Premium</th>
              <th class="border border-blue-300 p-2">Femina Plus</th>
              <th class="border border-blue-300 p-2">Femina Premium</th>
              <th class="border border-blue-300 p-2">Action</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="entry in entries" :key="entry.entry_id" class="hover:bg-blue-50 transition">
              <td class="border border-blue-300 p-2">{{ entry.memberName }}</td>
              <td class="border border-blue-300 p-2">{{ entry.dob }}</td>
              <td class="border border-blue-300 p-2 text-center">{{ entry.age }}</td>
              <td class="border border-blue-300 p-2 text-center">{{ entry.gender }}</td>
              <td class="border border-blue-300 p-2">{{ entry.relationship }}</td>
              <td class="border border-blue-300 p-2">{{ formatAmount(entry.inpatientBenefit) }}</td>
              <td class="border border-blue-300 p-2 bg-gray-50">{{ formatAmount(calculatePremium('inpatient', entry.inpatientBenefit, entry.relationship, entry.age)) }}</td>
              <td class="border border-blue-300 p-2">{{ formatAmount(entry.outpatientBenefit) }}</td>
              <td class="border border-blue-300 p-2 bg-gray-50">{{ formatAmount(calculatePremium('outpatient', entry.outpatientBenefit, entry.relationship, entry.age)) }}</td>
              <td class="border border-blue-300 p-2">{{ formatAmount(entry.maternityBenefit) }}</td>
              <td class="border border-blue-300 p-2 bg-gray-50">{{ formatAmount(calculatePremium('maternity', entry.maternityBenefit, entry.relationship, entry.age)) }}</td>
              <td class="border border-blue-300 p-2">{{ entry.feminaPlusBenefit || '-' }}</td>
              <td class="border border-blue-300 p-2 bg-gray-50">{{ formatAmount(calculateFeminaPlusPremium(entry.feminaPlusBenefit)) }}</td>
              <td class="border border-blue-300 p-2 text-center">
                <button
                  @click="deleteEntry(entry.entry_id)"
                  :disabled="isDeleteDisabled(entry.relationship)"
                  class="text-red-600 hover:text-red-800 disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12"/>
                  </svg>
                </button>
              </td>
            </tr>
          </tbody>
        </table>

        <!-- Mobile Table -->
        <div class="md:hidden space-y-4">
          <div v-for="entry in entries" :key="entry.entry_id" class="border border-blue-200 p-4 rounded-lg shadow-sm">
            <div class="grid grid-cols-2 gap-2 text-sm">
              <div class="font-semibold text-blue-900">Member Name:</div>
              <div>{{ entry.memberName }}</div>
              <div class="font-semibold text-blue-900">DOB:</div>
              <div>{{ entry.dob }}</div>
              <div class="font-semibold text-blue-900">Age:</div>
              <div>{{ entry.age }}</div>
              <div class="font-semibold text-blue-900">Gender:</div>
              <div>{{ entry.gender }}</div>
              <div class="font-semibold text-blue-900">Relationship:</div>
              <div>{{ entry.relationship }}</div>
              <div class="font-semibold text-blue-900">Inpatient:</div>
              <div>{{ formatAmount(entry.inpatientBenefit) }} ({{ formatAmount(calculatePremium('inpatient', entry.inpatientBenefit, entry.relationship, entry.age)) }})</div>
              <div class="font-semibold text-blue-900">Outpatient:</div>
              <div>{{ formatAmount(entry.outpatientBenefit) }} ({{ formatAmount(calculatePremium('outpatient', entry.outpatientBenefit, entry.relationship, entry.age)) }})</div>
              <div class="font-semibold text-blue-900">Maternity:</div>
              <div>{{ formatAmount(entry.maternityBenefit) }} ({{ formatAmount(calculatePremium('maternity', entry.maternityBenefit, entry.relationship, entry.age)) }})</div>
              <div class="font-semibold text-blue-900">Femina Plus:</div>
              <div>{{ entry.feminaPlusBenefit || '-' }} ({{ formatAmount(calculateFeminaPlusPremium(entry.feminaPlusBenefit)) }})</div>
            </div>
            <div class="mt-4 flex justify-end">
              <button
                @click="deleteEntry(entry.entry_id)"
                :disabled="isDeleteDisabled(entry.relationship)"
                class="text-red-600 hover:text-red-800 disabled:opacity-50 disabled:cursor-not-allowed font-semibold text-sm"
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Premium Summary Cards -->
      <div class="mt-8 grid grid-cols-1 md:grid-cols-5 gap-4">
        <div class="bg-gradient-to-r from-blue-500 to-blue-600 rounded-lg shadow-lg p-4 text-white">
          <p class="text-sm opacity-90">Basic Premium</p>
          <p class="text-2xl font-bold">{{ formatAmount(basicPremium) }}</p>
        </div>
        <div class="bg-gradient-to-r from-purple-500 to-purple-600 rounded-lg shadow-lg p-4 text-white" v-if="loadingPercentage > 0">
          <p class="text-sm opacity-90">Loading ({{ loadingPercentage }}%)</p>
          <p class="text-2xl font-bold">{{ formatAmount(loadingAmount) }}</p>
        </div>
        <div class="bg-gradient-to-r from-green-500 to-green-600 rounded-lg shadow-lg p-4 text-white" v-if="discountPercentage > 0">
          <p class="text-sm opacity-90">Discount ({{ discountPercentage }}%)</p>
          <p class="text-2xl font-bold">{{ formatAmount(discountAmount) }}</p>
        </div>
        <div class="bg-gradient-to-r from-yellow-500 to-yellow-600 rounded-lg shadow-lg p-4 text-white">
          <p class="text-sm opacity-90">Levies @ 0.45%</p>
          <p class="text-2xl font-bold">{{ formatAmount(levies) }}</p>
        </div>
        <div class="bg-gradient-to-r from-orange-500 to-orange-600 rounded-lg shadow-lg p-4 text-white">
          <p class="text-sm opacity-90">Stamp Duty</p>
          <p class="text-2xl font-bold">{{ formatAmount(stampDuty) }}</p>
        </div>
        <div class="bg-gradient-to-r from-red-600 to-red-700 rounded-lg shadow-lg p-4 text-white md:col-span-5">
          <p class="text-sm opacity-90">Total Premium (after adjustments)</p>
          <p class="text-3xl font-bold">{{ formatAmount(adjustedTotalPremium) }}</p>
          <p class="text-xs opacity-75 mt-1" v-if="loadingPercentage > 0 || discountPercentage > 0">
            Applied: {{ loadingPercentage > 0 ? `+${loadingPercentage}%` : '' }} {{ discountPercentage > 0 ? `-${discountPercentage}%` : '' }}
          </p>
        </div>
      </div>
    </div>

    <!-- Empty State -->
    <div v-else class="text-center py-12">
      <div class="text-6xl mb-4">📋</div>
      <h3 class="text-xl font-semibold text-gray-600 mb-2">No Members Added Yet</h3>
      <p class="text-gray-500">Please add members above to generate an insurance quote</p>
    </div>
  </div>
  <!--End of pdf report -->

  <div v-if="entries.length" class="p-6 max-w-7xl mx-auto bg-white rounded-lg shadow-md mt-6 flex justify-center space-x-4">
    <button @click="clearEntries" type="button" class="bg-red-600 hover:bg-red-700 text-white font-bold py-3 px-6 rounded-lg shadow-md transition duration-300 transform hover:scale-105">
      Clear Entries
    </button>
    <button @click="printQuote" type="button" class="bg-blue-700 hover:bg-blue-800 text-white font-bold py-3 px-6 rounded-lg shadow-md transition duration-300 transform hover:scale-105">
      Generate Quote
    </button>
    <button @click="backHome" type="button" class="bg-green-600 hover:bg-green-700 text-white font-bold py-3 px-6 rounded-lg shadow-md transition duration-300 transform hover:scale-105">
      Back Home
    </button>
  </div>

</template>

<script>
import benefits from '@/data/afyanafuu.json';
import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';
import {
  drawHeaderBanner, drawClientInfo, drawSectionBar, ensureSpace,
  drawBulletList, addPageNumber, drawFooterBlock, drawPremiumSummaryBoxes,
  generateReference, THEME,
} from '@/utils/pdfLayout';

export default {
  data() {
    return {
      form: {
        memberName: '',
        dob: '',
        gender: 'M',
        relationship: 'Principal',
        inpatientBenefit: 500000,
        outpatientBenefit: null,
        maternityBenefit: null,
        feminaPlusBenefit: null
      },
      entries: JSON.parse(localStorage.getItem('entries')) || [],
      benefits,
      logo: require('@/assets/logo.png'),
      clientDetails: JSON.parse(localStorage.getItem('clientDetails')) ||
      {
        name: this.$route.query.name || '',
        email: this.$route.query.email || '',
        telephone: this.$route.query.phone || '',
       },
      previewPremium: 0,
      loadingPercentage: 0,
      discountPercentage: 0,
      dependantRows: [],
      dependantError: ''
    };
  },
  mounted() {
    this.syncBenefits();

    // Load saved loading/discount values
    const savedLoading = localStorage.getItem('afyanafuu_loading_percentage');
    const savedDiscount = localStorage.getItem('afyanafuu_discount_percentage');
    if (savedLoading) this.loadingPercentage = parseFloat(savedLoading);
    if (savedDiscount) this.discountPercentage = parseFloat(savedDiscount);
  },
  computed: {
    inpatientAmounts() {
      return [100000, 300000, 500000, 750000, 1000000];
    },
    outpatientAmounts() {
      return [null, 30000, 40000, 50000, 75000, 100000];
    },
    maternityAmounts() {
      return [null, 50000, 75000, 100000];
    },
    feminaPlusBenefits() {
      return [null,'Silver', 'Gold', 'Platinum'];
    },
    isMaternityDisabled() {
      return this.form.gender === 'M' || this.form.relationship === 'Child';
    },

    hasPrincipal() {
      return this.entries.some(e => e.relationship === 'Principal');
    },
    principalEntry() {
      return this.entries.find(e => e.relationship === 'Principal') || null;
    },
    existingDependants() {
      return this.entries.filter(e => e.relationship !== 'Principal');
    },

    basicPremium() {
      return this.entries.reduce((total, entry) => {
        let inpatientPremium = entry.inpatientBenefit ? this.calculatePremium('inpatient', entry.inpatientBenefit, entry.relationship, entry.age) : 0;
        let outpatientPremium = entry.outpatientBenefit ? this.calculatePremium('outpatient', entry.outpatientBenefit, entry.relationship, entry.age) : 0;
        let maternityPremium = entry.maternityBenefit ? this.calculatePremium('maternity', entry.maternityBenefit, entry.relationship, entry.age) : 0;
        let feminaPlusPremium = entry.feminaPlusBenefit ? this.calculateFeminaPlusPremium(entry.feminaPlusBenefit) : 0;
        return total + inpatientPremium + outpatientPremium + maternityPremium + feminaPlusPremium;
      }, 0);
    },

    loadingAmount() {
      return this.basicPremium * (this.loadingPercentage / 100);
    },
    discountAmount() {
      return this.basicPremium * (this.discountPercentage / 100);
    },
    adjustedBasicPremium() {
      return this.basicPremium + this.loadingAmount - this.discountAmount;
    },

    stampDutyTotal() {
      return this.entries.reduce((total, entry) => {
        let feminaPlusPremium = entry.feminaPlusBenefit ? this.calculateFeminaPlusPremium(entry.feminaPlusBenefit) : 0;
        return total + feminaPlusPremium;
      }, 0);
    },

    levies() {
      return this.adjustedBasicPremium * 0.0045;
    },
    stampDuty() {
      if(this.stampDutyTotal > 0){
        return this.entries.length * 40 + 40;
      }
      return this.entries.length * 40;
    },
    adjustedTotalPremium() {
      return this.adjustedBasicPremium + this.levies + this.stampDuty;
    },
    totalPremium() {
      return this.basicPremium + this.levies + this.stampDuty;
    },
    minDate() {
      const today = new Date();
      const year = today.getFullYear() - 20;
      const month = ('0' + (today.getMonth() + 1)).slice(-2);
      const day = ('0' + today.getDate()).slice(-2);
      return `${year}-${month}-${day}`;
    },
    maxDate() {
      const today = new Date();
      const year = today.getFullYear();
      const month = ('0' + (today.getMonth() + 1)).slice(-2);
      const day = ('0' + today.getDate()).slice(-2);
      return `${year}-${month}-${day}`;
    },
  },
  methods: {
    updateLoadingDiscount() {
      if (this.loadingPercentage < 0) this.loadingPercentage = 0;
      if (this.loadingPercentage > 100) this.loadingPercentage = 100;
      if (this.discountPercentage < 0) this.discountPercentage = 0;
      if (this.discountPercentage > 100) this.discountPercentage = 100;

      localStorage.setItem('afyanafuu_loading_percentage', this.loadingPercentage);
      localStorage.setItem('afyanafuu_discount_percentage', this.discountPercentage);
    },

    formatAmount(amount) {
        if (amount === null || amount === undefined) {
            return '-';
        }
        return amount.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 });
    },

    addDependantRow() {
      this.dependantRows.push({ name: '', relationship: '', gender: '', dob: '', maternityBenefit: null, feminaPlusBenefit: null });
    },

    removeDependantRow(index) {
      this.dependantRows.splice(index, 1);
    },

    availableDependantRelationshipOptions(index) {
      const spouseTakenInEntries = this.entries.some(e => e.relationship === 'Spouse');
      const spouseTakenInRows = this.dependantRows.some((r, i) => i !== index && r.relationship === 'Spouse');
      const options = [];
      if (!spouseTakenInEntries && !spouseTakenInRows) {
        options.push('Spouse');
      }
      options.push('Child');
      return options;
    },

    calculateDependantPreviewPremium(row) {
      if (!row.dob || !row.gender || !row.relationship) return 0;
      const shared = JSON.parse(localStorage.getItem('firstEntryBenefits')) || {};
      const age = this.calculateAge(row.dob);
      let total = 0;
      if (shared.inpatientBenefit) total += this.calculatePremium('inpatient', shared.inpatientBenefit, row.relationship, age);
      if (shared.outpatientBenefit) total += this.calculatePremium('outpatient', shared.outpatientBenefit, row.relationship, age);
      if (row.gender === 'F' && row.relationship !== 'Child') {
        if (row.maternityBenefit) total += this.calculatePremium('maternity', row.maternityBenefit, row.relationship, age);
        if (row.feminaPlusBenefit) total += this.calculateFeminaPlusPremium(row.feminaPlusBenefit);
      }
      return total;
    },

    validateDependantRows() {
      for (const row of this.dependantRows) {
        if (!row.name || !row.name.trim()) {
          this.dependantError = 'Please provide a name for every dependant.';
          return false;
        }
        if (!row.relationship) {
          this.dependantError = `Please select a relationship for "${row.name}".`;
          return false;
        }
        if (!row.gender) {
          this.dependantError = `Please select a gender for "${row.name}".`;
          return false;
        }
        if (!row.dob) {
          this.dependantError = `Please provide a date of birth for "${row.name}".`;
          return false;
        }
        if (new Date(row.dob) > new Date()) {
          this.dependantError = `"${row.name}"'s date of birth cannot be in the future.`;
          return false;
        }
      }
      this.dependantError = '';
      return true;
    },

    saveDependants() {
      if (this.dependantRows.length === 0) return;
      if (!this.validateDependantRows()) return;

      const shared = JSON.parse(localStorage.getItem('firstEntryBenefits')) || {};
      const newEntries = this.dependantRows.map((row, i) => ({
        memberName: row.name,
        dob: row.dob,
        gender: row.gender,
        relationship: row.relationship,
        inpatientBenefit: shared.inpatientBenefit,
        outpatientBenefit: shared.outpatientBenefit,
        maternityBenefit: (row.gender === 'F' && row.relationship !== 'Child') ? row.maternityBenefit : null,
        feminaPlusBenefit: (row.gender === 'F' && row.relationship !== 'Child') ? row.feminaPlusBenefit : null,
        age: this.calculateAge(row.dob),
        entry_id: Date.now() + i
      }));

      this.entries.push(...newEntries);
      localStorage.setItem('entries', JSON.stringify(this.entries));
      this.dependantRows = [];
      this.dependantError = '';
    },

    calculatePreviewBenefit(type, limit) {
      if (!limit) return 0;

      if (type === 'maternity') {
        return this.benefits[type][limit] || 0;
      }

      if (type === 'femina') {
        return this.benefits['feminaPlus'][limit] || 0;
      }

      const age = this.form.dob ? this.calculateAge(this.form.dob) : 30;

      const getAgeRangeOutPatient = (age) => {
        if (age <= 20) return "20";
        if (age > 20 && age <= 40) return "40";
        if (age > 40 && age <= 60) return "60";
        if (age > 60 && age <= 75) return "75";
        return "40";
      };

      const getAgeRangeKey = (age) => {
        if (age <= 20) return "20";
        if (age > 20 && age <= 40) return "40";
        if (age > 40 && age <= 54) return "54";
        if (age > 54 && age <= 65) return "65";
        if (age > 65 && age <= 75) return "75";
        return "40";
      };

      if (type === 'outpatient') {
        const ageRangeKey = getAgeRangeOutPatient(age);
        return this.benefits[type][ageRangeKey][limit] || 0;
      }

      if (type === 'inpatient') {
        const ageRangeKey = getAgeRangeKey(age);
        return this.benefits['inpatient'][ageRangeKey][limit] || 0;
      }

      return 0;
    },

    calculatePreviewFeminaPlus(benefit) {
      if (!benefit) return 0;
      return this.benefits['feminaPlus'][benefit] || 0;
    },

    calculatePreviewPremium() {
      if (!this.form.dob) {
        this.previewPremium = 0;
        return;
      }

      let total = 0;
      total += this.calculatePreviewBenefit('inpatient', this.form.inpatientBenefit);
      total += this.calculatePreviewBenefit('outpatient', this.form.outpatientBenefit);

      if (this.form.gender === 'F' && this.form.relationship !== 'Child') {
        total += this.calculatePreviewBenefit('maternity', this.form.maternityBenefit);
        total += this.calculatePreviewFeminaPlus(this.form.feminaPlusBenefit);
      }

      this.previewPremium = total;
    },

    calculateTotalPremium(entry) {
        let total = 0;
        if (entry.inpatientBenefit) {
            total += this.calculatePremium('inpatient', entry.inpatientBenefit, entry.relationship, entry.age);
        }
        if (entry.outpatientBenefit) {
            total += this.calculatePremium('outpatient', entry.outpatientBenefit, entry.relationship, entry.age);
        }
        if (entry.maternityBenefit) {
            total += this.calculatePremium('maternity', entry.maternityBenefit, entry.relationship, entry.age);
        }
        if (entry.feminaPlusBenefit) {
            total += this.calculateFeminaPlusPremium(entry.feminaPlusBenefit);
        }
        return total;
    },

    calculatePremium(type, limit, relationship, age) {
      if(type == 'maternity')
      return this.benefits[type][limit]

      const getAgeRangeKey = (age) => {
        if (age <= 20) return "20";
        if (age > 20 && age <= 40) return "40";
        if (age > 40 && age <= 54) return "54";
        if (age > 54 && age <= 65) return "65";
        if (age > 65 && age <= 75) return "75";
        return null;
      };

      const getAgeRangeOutPatient = (age) => {
        if (age <= 20) return "20";
        if (age > 20 && age <= 40) return "40";
        if (age > 40 && age <= 60) return "60";
        if (age > 60 && age <= 75) return "75";
        return null;
      };

      if (type === 'outpatient') {
        const ageRangeKey = getAgeRangeOutPatient(age);
        if (ageRangeKey) {
          return this.benefits[type][ageRangeKey][limit];
        }
      }

      if (type === 'inpatient') {
        const ageRangeKey = getAgeRangeKey(age);
        if (ageRangeKey) {
          return this.benefits['inpatient'][ageRangeKey][limit];
        }
      }

      return null;
    },

    calculateFeminaPlusPremium(benefit) {
      return this.benefits['feminaPlus'][benefit] || null;
    },

    addEntry() {
      const age = this.calculateAge(this.form.dob);
      const entry_id = Date.now();
      const newEntry = { ...this.form, age, entry_id };

      if (this.entries.length === 0) {
        localStorage.setItem('firstEntryBenefits', JSON.stringify({
          inpatientBenefit: this.form.inpatientBenefit,
          outpatientBenefit: this.form.outpatientBenefit,
        }));
      }

      this.entries.push(newEntry);
      localStorage.setItem('entries', JSON.stringify(this.entries));
      this.resetForm();
      this.syncBenefits();
      this.previewPremium = 0;
    },

    syncBenefits() {
      const firstEntryBenefits = JSON.parse(localStorage.getItem('firstEntryBenefits'));
      if (firstEntryBenefits) {
        this.form.inpatientBenefit = firstEntryBenefits.inpatientBenefit;
        this.form.outpatientBenefit = firstEntryBenefits.outpatientBenefit;
      }
    },

    deleteEntry(id) {
      this.entries = this.entries.filter(entry => entry.entry_id !== id);
      localStorage.setItem('entries', JSON.stringify(this.entries));
    },

    isDeleteDisabled(relationship) {
      return relationship === 'Principal';
    },

    resetForm() {
      this.form = {
        memberName: '',
        dob: '',
        gender: 'M',
        relationship: 'Principal',
        inpatientBenefit: JSON.parse(localStorage.getItem('firstEntryBenefits'))?.inpatientBenefit || 500000,
        outpatientBenefit: JSON.parse(localStorage.getItem('firstEntryBenefits'))?.outpatientBenefit || null,
        maternityBenefit: null,
        feminaPlusBenefit: null
      };
    },

    clearEntries() {
      this.entries = [];
      localStorage.removeItem('entries');
      localStorage.removeItem('firstEntryBenefits');
    },

    calculateAge(dob) {
      const birthDate = new Date(dob);
      const today = new Date();
      let age = today.getFullYear() - birthDate.getFullYear();
      const monthDifference = today.getMonth() - birthDate.getMonth();
      if (monthDifference < 0 || (monthDifference === 0 && today.getDate() < birthDate.getDate())) {
        age--;
      }
      return age;
    },

    printQuote() {
        const doc = new jsPDF('p', 'mm', 'a4');
        const margin = 14;
        const pageWidth = doc.internal.pageSize.getWidth();
        const pageHeight = doc.internal.pageSize.getHeight();
        const contentWidth = pageWidth - margin * 2;

        const currentDate = new Date();
        const timestamp = currentDate.toLocaleString();
        const day = String(currentDate.getDate()).padStart(2, '0');
        const month = String(currentDate.getMonth() + 1).padStart(2, '0');
        const year = currentDate.getFullYear();
        const get_date = `${day}/${month}/${year}`;
        const reference = generateReference('ANQ');

        const pageFooterHook = (data) => {
          addPageNumber(doc, data.pageNumber, pageHeight, pageWidth, margin);
        };

        let y = drawHeaderBanner(doc, {
          title: 'AFYA NAFUU HEALTH INSURANCE',
          logo: this.logo,
          pageWidth, margin,
          timestampLabel: `APA Afya Nafuu quotation tool - ${timestamp}`,
        });
        y = drawClientInfo(doc, this.clientDetails, y, margin);

        // Member benefits table
        y = drawSectionBar(doc, 'MEMBER BENEFITS', y, margin, contentWidth);
        autoTable(doc, {
            startY: y,
            head: [['Member Name', 'DOB', 'Age', 'Gender', 'Relationship', 'Inpatient Limit', 'Outpatient Limit', 'Maternity Limit', 'Femina Plus']],
            body: this.entries.map(entry => [
                entry.memberName,
                entry.dob,
                this.calculateAge(entry.dob),
                entry.gender,
                entry.relationship,
                this.formatAmount(entry.inpatientBenefit) || 'N/A',
                this.formatAmount(entry.outpatientBenefit) || 'N/A',
                this.formatAmount(entry.maternityBenefit) || 'N/A',
                entry.feminaPlusBenefit || '-'
            ]),
            margin: { left: margin, right: margin },
            theme: 'grid',
            headStyles: { fillColor: THEME.navy, textColor: 255, fontSize: 8.5, halign: 'center', valign: 'middle' },
            bodyStyles: { fontSize: 8, valign: 'middle', halign: 'center' },
            columnStyles: { 0: { halign: 'left' } },
            didDrawPage: pageFooterHook
        });
        y = doc.previousAutoTable.finalY + 8;

        // Premium breakdown table
        y = ensureSpace(doc, y, 20, pageHeight, margin);
        y = drawSectionBar(doc, 'PREMIUM BREAKDOWN', y, margin, contentWidth);
        autoTable(doc, {
            startY: y,
            head: [['Member Name', 'DOB', 'Age', 'Gender', 'Inpatient Premium', 'Outpatient Premium', 'Maternity Premium', 'Femina Premium', 'Total Premiums']],
            body: this.entries.map(entry => [
                entry.memberName,
                entry.dob,
                this.calculateAge(entry.dob),
                entry.gender,
                entry.inpatientBenefit ? this.formatAmount(this.calculatePremium('inpatient', entry.inpatientBenefit, entry.relationship, entry.age)) : 'N/A',
                entry.outpatientBenefit ? this.formatAmount(this.calculatePremium('outpatient', entry.outpatientBenefit, entry.relationship, entry.age)) : 'N/A',
                entry.maternityBenefit ? this.formatAmount(this.calculatePremium('maternity', entry.maternityBenefit, entry.relationship, entry.age)) : 'N/A',
                entry.feminaPlusBenefit ? this.formatAmount(this.calculateFeminaPlusPremium(entry.feminaPlusBenefit)) : 'N/A',
                this.formatAmount(this.calculateTotalPremium(entry))
            ]),
            margin: { left: margin, right: margin },
            theme: 'grid',
            headStyles: { fillColor: THEME.navy, textColor: 255, fontSize: 8.5, halign: 'center', valign: 'middle' },
            bodyStyles: { fontSize: 8, valign: 'middle', halign: 'center' },
            columnStyles: { 0: { halign: 'left' } },
            didDrawPage: pageFooterHook
        });
        y = doc.previousAutoTable.finalY + 10;

        // Premium summary boxes
        y = ensureSpace(doc, y, 70, pageHeight, margin);
        y = drawSectionBar(doc, 'PREMIUM SUMMARY', y, margin, contentWidth);
        y = drawPremiumSummaryBoxes(doc, y, margin, contentWidth, {
          basicPremium: this.basicPremium,
          loadingPercentage: this.loadingPercentage,
          loadingAmount: this.loadingAmount,
          discountPercentage: this.discountPercentage,
          discountAmount: this.discountAmount,
          adjustedPremium: this.adjustedBasicPremium,
          levies: this.levies,
          stampDuty: this.stampDuty,
          totalDue: this.adjustedTotalPremium,
          totalMembers: this.entries.length,
          totalFamilies: 1,
          formatCurrency: this.formatCurrency,
        });

        // Terms & Conditions
        y = ensureSpace(doc, y, 20, pageHeight, margin);
        y = drawSectionBar(doc, 'TERMS & CONDITIONS', y, margin, contentWidth, { fill: THEME.red, gap: 3 });

        y = ensureSpace(doc, y, 15, pageHeight, margin);
        y = drawSectionBar(doc, 'WAITING PERIODS', y, margin, contentWidth, { height: 6, fontSize: 9 });
        y = drawBulletList(doc, [
          '30 days for illness-related treatment',
          '30 days for COVID-19 related treatment',
          '90 days for surgical procedures excluding pre-existing conditions',
          '10 months for Pregnancy related conditions',
          '12 months for pre-existing, chronic, HIV/AIDS, and congenital related conditions whether newly diagnosed or existing',
          '12 months for Fibroid, Hernias, Adenoidectomy, tonsillectomy, and Haemorrhoids treatment',
          'Waiting period waived in accidental cases',
          'Any undeclared pre-existing conditions will remain excluded for the lifetime of the policy'
        ], margin + 2, y, contentWidth - 4, pageHeight, margin);
        y += 4;

        y = ensureSpace(doc, y, 15, pageHeight, margin);
        y = drawSectionBar(doc, 'DOCUMENTATION REQUIRED', y, margin, contentWidth, { height: 6, fontSize: 9 });
        y = drawBulletList(doc, [
          'Duly filled APA medical application form',
          "KYC (ID, KRA PIN, spouse's ID, Birth certificate/notification for the children)",
          'Any applicant who is 60 years and above must submit a current medical report on application for review',
          'Cover will commence after proof of payment is received.'
        ], margin + 2, y, contentWidth - 4, pageHeight, margin);
        y += 4;

        y = ensureSpace(doc, y, 15, pageHeight, margin);
        y = drawSectionBar(doc, 'PAYMENT OPTIONS', y, margin, contentWidth, { height: 6, fontSize: 9 });
        y = drawBulletList(doc, [
          'Bank transfer or Cheque deposits to APA medical bank account at NCBA Account No. 6447560039',
          'Insurance Premium Financing (IPF) – maximum of 4 instalments. IPF documents to be received on or before the renewal date of the policy period.',
          'Mpesa Paybill number 511600, Account: Name of the Principal member'
        ], margin + 2, y, contentWidth - 4, pageHeight, margin);
        y += 6;

        y = ensureSpace(doc, y, 10, pageHeight, margin);
        doc.setFont('helvetica', 'bold');
        doc.setFontSize(9);
        doc.text('NB: This quote is valid for only 90 days from the date of issue.', margin, y);
        y += 10;

        y = ensureSpace(doc, y, 20, pageHeight, margin);
        drawFooterBlock(doc, y, margin, pageWidth, get_date, reference, 'Afya Nafuu Quote');

        doc.save('quote.pdf');
        this.saveReport();
    },

    formatCurrency(value) {
        return new Intl.NumberFormat('en-KE', { style: 'currency', currency: 'KES' }).format(value);
    },

    backHome() {
      this.entries = [];
      localStorage.removeItem('entries');
      this.$router.push('/');
    },

    saveReport() {
      const report = {
        clientName: this.clientDetails.name,
        email: this.clientDetails.email,
        phone: this.clientDetails.phone,
        numberOfEntries: this.entries.length,
        totalPremium: this.adjustedTotalPremium.toFixed(2),
        loadingPercentage: this.loadingPercentage,
        discountPercentage: this.discountPercentage
      };
      const reportJson = JSON.stringify(report);
      console.log('Report saved:', reportJson);
    },
  }
};
</script>

<style scoped>
/* Add any additional styling here */
</style>
